module.exports = __webpack_public_path__ + "img/rightSide.edb53e8.webp";